var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-notice"},[_c('div',{staticClass:"home-notice-list"},[_c('div',{staticClass:"notice-left"},[_c('i',{staticClass:"icon-notice"}),_c('span',[_vm._v(_vm._s(_vm.$t("homePageIndex.text68"))+"：")])]),_c('Notice')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }